

export function createSelectOptions(rules, data) {
    let options = []

    data[rules.loopField].forEach(object => {

        let option = {}

        // label
        let labelString = ''
        rules.label.forEach((label, index) => {
            labelString = labelString.concat(`${object[label]}${index == rules.label.length - 1 ? '' : ' '}`)
        })
        option['label'] = labelString

        // value
        option['id'] = object['id']

        option['data'] = {...object}

        // group
        option['group'] = null

        if(rules.groupBy) {
            if(rules.groupBy.includes(".")) {
                const allNestingKeys = rules.groupBy.split(".")
                let currentValue = {...object}
                allNestingKeys.forEach(nestedKey => {
                    currentValue = currentValue[nestedKey] ? currentValue[nestedKey] : ""
                })
                option['group'] = currentValue
            } else {
                option['group'] = object[rules.groupBy]
            }
            
        }

        // filtering rules
        if('filterField' in rules && 'filterValue' in rules){
            if(object[rules.filterField] == rules.filterValue) {
                options.push(option)
            }
        } else {
            options.push(option)
        }
        
    })

    // sort the options by group

    return options.sort((a, b) => {
        if(a.group < b.group) {
            return -1;
        }
        if(a.group > b.group) {
            return 1;
        }
        return 0;
    })
} 